<div class="container-fluid courier-report-settings">
    <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
            <h2>Futár riport beállítások</h2>
            <p class="text-muted mb-0">
                A mentés új, időzített verziót hoz létre; a korábbi értékek megmaradnak.
            </p>
        </div>
        <span class="badge badge-secondary">HU</span>
    </div>

    <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
    <div *ngIf="successMessage" class="alert alert-success">{{ successMessage }}</div>

    <div class="card mb-4">
        <div class="card-header">Napi riport futtatása</div>
        <div class="card-body">
            <p class="mb-2">
                A próbaüzem csak a konfigurációt, a 7 lépcsős sorrendet és a sheet-sémákat ellenőrzi,
                és kiírja, melyik integráció engedélyezett. Nem hív külső végpontot, és nem ír sheetet.
                Staging környezetben éles végpont (éles gateway/adatbázis, SumUp, éles Revolut, Google Maps) nem hívható,
                és éles munkafüzet nem írható.
            </p>
            <button class="btn btn-outline-primary" type="button" [disabled]="isStartingRun"
                (click)="startDryRun()">
                {{ isStartingRun ? 'Indítás…' : 'Biztonságos próbaindítás' }}
            </button>
            <button class="btn btn-danger ml-2" type="button" [disabled]="isStartingRun"
                (click)="startLiveRun()">Teljes riport futtatása</button>
            <button class="btn btn-outline-secondary ml-2" type="button" [disabled]="isExporting"
                (click)="exportReport('szb')">SZB Excel letöltése</button>
            <button class="btn btn-outline-secondary ml-2" type="button" [disabled]="isExporting"
                (click)="exportReport('sum')">SUM Excel letöltése</button>
            <div *ngIf="reportRun" class="mt-3">
                <strong>Állapot:</strong> {{ reportRun.state }}
                <span *ngIf="reportRun.currentStage"> — {{ reportRun.currentStage }}</span>
                <div *ngIf="reportRun.error" class="text-danger">{{ reportRun.error }}</div>
                <ul class="small mt-2 mb-0">
                    <li *ngFor="let message of reportRun.messages">{{ message }}</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="card mb-4">
        <div class="card-header">Új beállításverzió</div>
        <div class="card-body" *ngIf="!isLoading; else loading">
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="carRentalDailyFee">Autóbérlés szorzó / napi levonás (Ft)</label>
                    <input id="carRentalDailyFee" class="form-control" type="number" min="0" step="1"
                        [(ngModel)]="configuration.carRentalDailyFee" />
                </div>
                <div class="form-group col-md-4">
                    <label for="amortizationPerKm">Amortizáció (Ft/km)</label>
                    <input id="amortizationPerKm" class="form-control" type="number" min="0" step="0.01"
                        [(ngModel)]="configuration.amortizationPerKm" />
                </div>
                <div class="form-group col-md-4">
                    <label for="contributionMargin">Alapértelmezett Fedezet4 keret (Ft)</label>
                    <input id="contributionMargin" class="form-control" type="number" min="0" step="1"
                        [(ngModel)]="configuration.defaultContributionMarginPool" />
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="validFrom">Érvényes ettől</label>
                    <input id="validFrom" class="form-control" type="datetime-local"
                        [(ngModel)]="configuration.validFrom" />
                </div>
                <div class="form-group col-md-8">
                    <label for="changeReason">Módosítás indoklása</label>
                    <input id="changeReason" class="form-control" maxlength="1000"
                        [(ngModel)]="configuration.changeReason" />
                </div>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-3 mb-2">
                <h5 class="mb-0">Jutalékszabályok</h5>
                <button class="btn btn-outline-primary btn-sm" type="button" (click)="addCommissionRule()">
                    Új szabály
                </button>
            </div>

            <div class="table-responsive">
                <table class="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th>Szerződéstípus</th>
                            <th>Jutalék (%)</th>
                            <th>Számítás aktív</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let rule of configuration.commissionRules; let i = index">
                            <td><input class="form-control" maxlength="128" [(ngModel)]="rule.contractType" /></td>
                            <td><input class="form-control" type="number" min="0" step="0.01"
                                [(ngModel)]="rule.commissionPercent" /></td>
                            <td class="text-center align-middle">
                                <input type="checkbox" [(ngModel)]="rule.isCalculationEnabled" />
                            </td>
                            <td class="text-center align-middle">
                                <button class="btn btn-outline-danger btn-sm" type="button"
                                    (click)="removeCommissionRule(i)">Törlés</button>
                            </td>
                        </tr>
                        <tr *ngIf="configuration.commissionRules.length === 0">
                            <td colspan="4" class="text-muted text-center">Nincs megadott jutalékszabály.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-4 mb-2">
                <div>
                    <h5 class="mb-0">Futár díjtábla</h5>
                    <small class="text-muted">Az üres régió minden régióra érvényes.</small>
                </div>
                <button class="btn btn-outline-primary btn-sm" type="button" (click)="addRateCard()">
                    Új díjtétel
                </button>
            </div>

            <div class="table-responsive">
                <table class="table table-sm table-bordered rate-card-table">
                    <thead>
                        <tr>
                            <th>Szerződéstípus</th><th>Szerepkör</th><th>Régió</th>
                            <th>Óradíj</th><th>Picking/SKU</th><th>Delivery/rendelés</th>
                            <th>Pontossági bónusz</th><th>Panaszmentes bónusz</th><th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let rate of configuration.rateCards; let i = index">
                            <td><input class="form-control" [(ngModel)]="rate.contractType" /></td>
                            <td><input class="form-control" [(ngModel)]="rate.role" /></td>
                            <td><input class="form-control" [(ngModel)]="rate.region" /></td>
                            <td><input class="form-control" type="number" min="0" [(ngModel)]="rate.hourlyFee" /></td>
                            <td><input class="form-control" type="number" min="0" [(ngModel)]="rate.pickingFeePerSku" /></td>
                            <td><input class="form-control" type="number" min="0" [(ngModel)]="rate.deliveryFeePerOrder" /></td>
                            <td><input class="form-control" type="number" min="0" [(ngModel)]="rate.onTimeBonusPerOrder" /></td>
                            <td><input class="form-control" type="number" min="0" [(ngModel)]="rate.complaintFreeBonusPerOrder" /></td>
                            <td class="text-center align-middle">
                                <button class="btn btn-outline-danger btn-sm" type="button"
                                    (click)="removeRateCard(i)">Törlés</button>
                            </td>
                        </tr>
                        <tr *ngIf="configuration.rateCards.length === 0">
                            <td colspan="9" class="text-muted text-center">Nincs megadott díjtétel.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-4 mb-2">
                <div>
                    <h5 class="mb-0">Késési levonások</h5>
                    <small class="text-muted">Az alsó határ kizárt, a felső határ beleértendő, a legacy szabállyal egyezően.</small>
                </div>
                <button class="btn btn-outline-primary btn-sm" type="button" (click)="addLateStartRule()">
                    Új késési sáv
                </button>
            </div>

            <div class="table-responsive late-rule-table">
                <table class="table table-sm table-bordered">
                    <thead><tr><th>Minimum perc (&gt;)</th><th>Maximum perc (≤)</th><th>Levonás (Ft)</th><th></th></tr></thead>
                    <tbody>
                        <tr *ngFor="let rule of configuration.lateStartRules; let i = index">
                            <td><input class="form-control" type="number" min="0" [(ngModel)]="rule.minimumMinutesExclusive" /></td>
                            <td><input class="form-control" type="number" min="0" [(ngModel)]="rule.maximumMinutesInclusive" /></td>
                            <td><input class="form-control" type="number" min="0" [(ngModel)]="rule.deductionAmount" /></td>
                            <td class="text-center align-middle">
                                <button class="btn btn-outline-danger btn-sm" type="button"
                                    (click)="removeLateStartRule(i)">Törlés</button>
                            </td>
                        </tr>
                        <tr *ngIf="configuration.lateStartRules.length === 0">
                            <td colspan="4" class="text-muted text-center">Nincs megadott késési sáv.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <button class="btn btn-primary" type="button" [disabled]="isSaving" (click)="save()">
                {{ isSaving ? 'Mentés…' : 'Új verzió mentése' }}
            </button>
        </div>
        <ng-template #loading><div class="card-body text-muted">Betöltés…</div></ng-template>
    </div>

    <div class="card">
        <div class="card-header">Korábbi verziók</div>
        <div class="table-responsive">
            <table class="table table-sm mb-0">
                <thead>
                    <tr><th>Érvényesség</th><th>Autóbérlés</th><th>Amortizáció</th><th>Fedezet4</th><th>Módosította</th><th>Indoklás</th></tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of history">
                        <td>{{ item.validFrom | date:'yyyy.MM.dd. HH:mm' }} – {{ item.validTo ? (item.validTo | date:'yyyy.MM.dd. HH:mm') : 'jelenleg' }}</td>
                        <td>{{ item.carRentalDailyFee | number:'1.0-2' }} Ft/nap</td>
                        <td>{{ item.amortizationPerKm | number:'1.0-4' }} Ft/km</td>
                        <td>{{ item.defaultContributionMarginPool | number:'1.0-2' }} Ft</td>
                        <td>{{ item.createdBy }}</td>
                        <td>{{ item.changeReason }}</td>
                    </tr>
                    <tr *ngIf="history.length === 0"><td colspan="6" class="text-muted text-center">Még nincs mentett verzió.</td></tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
